/* eslint-disable react/no-array-index-key */
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import Link from 'next/link';
import React from 'react';
import Button from '../buttons/Button';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Box } from '../layout';
import { MidHeading, Text } from '../typography';
import { BookButton } from './PremierBookButton';
import {
  Container,
  PromoteFeaturesContainer,
  IconItem,
  IconsGrid,
  Wrapper,
  PromoteFeaturesImgContainer,
  PromoteFeaturesImg,
  PromoteFeaturesTitle,
  PromoteFeaturesList,
  PromoteFeaturesItem,
  IconsFeatureItem,
  IconsContainer,
  PpLogo,
  PnLogo,
} from './PromoteFeatures.style';

export interface PromoteFeaturesIcon {
  SVG: string;
  heading: string;
  text: string | JSX.Element;
  maxW?: number;
}

interface PromoteFeaturesProps {
  icons?: PromoteFeaturesIcon[];
  iconsMw?: number;
  mockup?: {
    src: string;
    alt: string;
    maxW: number;
  };
  mockupContent?: JSX.Element;
  featureTitle: string;
  features: (string | JSX.Element)[];
  button: BookButton;
  canBook: boolean;
  hideLogos?: boolean;
}

const PromoteFeatures: React.FC<PromoteFeaturesProps> = ({
  icons,
  mockup,
  mockupContent,
  featureTitle,
  features,
  button,
  iconsMw,
  canBook,
  hideLogos,
}) => {
  return (
    <Container data-testid="promote-features">
      {icons && (
        <Wrapper iconsMw={iconsMw}>
          <IconsGrid>
            {icons.map(({ SVG, heading, text: iconText, maxW: maxWidth }) => (
              <IconItem key={heading} maxW={maxWidth} data-testid="promote-grid-icon">
                <SVG />
                <div>
                  <MidHeading>{heading}</MidHeading>
                  <Text data-testid="promote-grid-icon-text">{iconText}</Text>
                </div>
              </IconItem>
            ))}
          </IconsGrid>
        </Wrapper>
      )}
      <PromoteFeaturesContainer noIcons={!icons?.length} hasContent={!!mockupContent}>
        <PromoteFeaturesImgContainer>
          {mockup && (
            <PromoteFeaturesImg
              src={mockup.src}
              alt={mockup.alt}
              maxW={mockup.maxW}
              data-testid="feature-mockup-image"
            />
          )}
          {mockupContent}
        </PromoteFeaturesImgContainer>
        <Box maxWidth={525}>
          <PromoteFeaturesTitle fontSize={22} mb={30} data-testid="feature-title">
            {featureTitle}
          </PromoteFeaturesTitle>
          <PromoteFeaturesList>
            {features.map((f, i) => (
              <PromoteFeaturesItem key={i} data-testid="features-item">
                <FontAwesomeIcon icon={faCheck} />
                {i === features.length - 1 && !hideLogos ? (
                  <IconsFeatureItem>
                    <Text as="span">{f}</Text>
                    <IconsContainer>
                      <PpLogo />
                      <PnLogo />
                    </IconsContainer>
                  </IconsFeatureItem>
                ) : (
                  <Text as="span">{f}</Text>
                )}
              </PromoteFeaturesItem>
            ))}
          </PromoteFeaturesList>
          {canBook && (
            <Link href={button.href} prefetch={false} className="link-button">
              <Button containerStyle={{ maxWidth: '290px', marginTop: '35px' }} testID="feature-btn">
                {button.text}
              </Button>
            </Link>
          )}
        </Box>
      </PromoteFeaturesContainer>
    </Container>
  );
};

export default PromoteFeatures;
